// Where a widget someone adds goes on a client pipeline: at the foot of its shelf, as wide as the shelf, its
// height its own. The gallery's Add, Connect's and every other add come through here (src/state/actions.ts
// addWidget). Light on purpose: the main app loads it, never the pipeline's views.

import { SPEC } from "../../../shared/catalog";
import { SHELF_W } from "../../../shared/pipeline";
import type { Board, Op, WidgetItem } from "../../../shared/types";
import { commit } from "../../state/actions";
import { boardItems, get } from "../../state/store";
import type { Placement } from "../kinds";

export const MIN_H = 112;
export const MAX_H = 640;

export function placeOnShelf(item: WidgetItem, board: Board): Placement {
  const on = boardItems(get(), board.id).filter((i): i is WidgetItem => i.kind === "widget");
  const y = on.length ? Math.max(...on.map((i) => i.y + i.h)) + 16 : 0;
  const h = Math.max(MIN_H, Math.min(MAX_H, SPEC[item.type]?.size[1] ?? 176));
  return { ops: [{ op: "item.put", item: { ...item, x: 0, y, w: SHELF_W, h } } as Op] };
}

/** A shelf widget moved one place up (-1) or down (1), trading places with the one there; check: only whether it can. */
export function shelfMove(id: string, dir: -1 | 1, check = false): boolean {
  const it = get().items[id];
  if (!it || it.kind !== "widget") return false;
  const shelf = boardItems(get(), it.boardId)
    .filter((i): i is WidgetItem => i.kind === "widget")
    .sort((a, b) => a.y - b.y || a.x - b.x || a.createdAt - b.createdAt);
  const at = shelf.findIndex((i) => i.id === id);
  const other = shelf[at + dir];
  if (!other) return false;
  if (check) return true;
  // the two trade places, and the shelf is laid out again top to bottom, so its order is its places
  const order = [...shelf];
  [order[at], order[at + dir]] = [order[at + dir], order[at]];
  let y = 0;
  const ops: Op[] = [];
  for (const w of order) {
    if (w.y !== y) ops.push({ op: "item.put", item: { ...w, y } });
    y += w.h + 16;
  }
  commit(ops, "Move widget");
  return true;
}
